import mutations from './appointmentReferral.mutations'
import actions from './appointmentReferral.actions'
import getters from './appointmentReferral.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
